import { render, staticRenderFns } from "./category-special.vue?vue&type=template&id=491912b4&"
import script from "./category-special.vue?vue&type=script&lang=js&"
export * from "./category-special.vue?vue&type=script&lang=js&"
import style0 from "./category-special.vue?vue&type=style&index=0&id=491912b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports